import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../css/CategoryGrid.css";
import { supabase } from "../lib/supabaseClient.ts";

const CategoryGridweb = () => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchCategories() {
      const { data, error } = await supabase
        .from("categories")
        .select("*")
        .gte("id", 80)
        .lte("id", 87)
        .order("id");

      if (error) {
        console.error("Error fetching categories:", error);
      } else {
        setCategories(data);
      }
    }

    fetchCategories();
  }, []);

  return (
    <div className="grid-wrapper">
      {categories.map((category) => (
        <div
          key={category.id}
          className="card"
          style={{ backgroundImage: `url(${category.image})` }}
          onClick={() =>
            navigate(`/category/${category.id}/${encodeURIComponent(category.name)}`)
          }
        >
          <div className="card-overlay">
            <p className="card-title">{category.name}</p>
            <div className="voir-plus-wrapper">
              {/* <img src="../figmaAssets/btn.png" alt="Voir plus" className="voir-plus-img" /> */}

            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CategoryGridweb;